import gudang from './gudang'

export default [...gudang]
